const SPREADSHEET_ID = "1N52BuSDULKrSeZUHJRg2UlifWeR3FyWbOxz0bfEsh90";
const GID = 0

export async function getTotalMedalCount() {
  const query = `
    SELECT D, COUNT(D)
    GROUP BY D
  `;

  const url =
    `https://docs.google.com/spreadsheets/d/${SPREADSHEET_ID}/gviz/tq` +
    `?gid=${GID}` +
    `&headers=1` +
    `&tqx=out:json` +
    `&tq=${encodeURIComponent(query)}`;

  const response = await fetch(url);
  const text = await response.text();

  const json = JSON.parse(
    text.substring(
      text.indexOf("{"),
      text.lastIndexOf("}") + 1
    )
  );

  const result = {
    Oro: 0,
    Argento: 0,
    Bronzo: 0,
  };

  json.table.rows.forEach(row => {
    const type = row.c[0]?.v;
    const count = Number(row.c[1]?.v ?? 0);

    if (type in result) {
      result[type] = count;
    }
  });

  return result;
}

export async function getMedalCount() {
  const query = `
    SELECT A, D, COUNT(D)
    GROUP BY A, D
    ORDER BY A DESC
    LABEL A 'season', D 'medal', COUNT(D) 'total'
  `;

  const url =
    `https://docs.google.com/spreadsheets/d/${SPREADSHEET_ID}/gviz/tq` +
    `?gid=${GID}` +
    `&headers=1` +
    `&tqx=out:json` +
    `&tq=${encodeURIComponent(query)}`;

  const response = await fetch(url);
  const text = await response.text();

  const json = JSON.parse(
    text.substring(
      text.indexOf('{'),
      text.lastIndexOf('}') + 1
    )
  );

  const rows = json.table.rows.map(row => ({
    season: row.c[0]?.v,
    type: row.c[1]?.v,
    count: Number(row.c[2]?.v ?? 0),
  }));

  return rows.reduce((result, row) => {
    let seasonData = result.find(
      item => item.season === row.season
    );

    if (!seasonData) {
      seasonData = {
        season: row.season,
        medals: {
          Oro: 0,
          Argento: 0,
          Bronzo: 0
        }
      };

      result.push(seasonData);
    }

    seasonData.medals[row.type] = row.count;

    return result;
  }, []);
}

export async function getMedalsBySeason(season) {
  const query = `
    SELECT B, C, D, E
    WHERE A = '${season}'
    ORDER BY B
    LABEL B 'torneo', C 'disciplina', D 'medaglia', E 'atleta'
  `;

  const url =
    `https://docs.google.com/spreadsheets/d/${SPREADSHEET_ID}/gviz/tq` +
    `?gid=${GID}` +
    `&headers=1` +
    `&tqx=out:json` +
    `&tq=${encodeURIComponent(query)}`;

  const response = await fetch(url);
  const text = await response.text();

  const json = JSON.parse(
    text.substring(
      text.indexOf("{"),
      text.lastIndexOf("}") + 1
    )
  );

  const rows = json.table.rows.map(row => ({
    tournament: row.c[0]?.v,
    speciality: row.c[1]?.v,
    type: row.c[2]?.v,
    athleteName: row.c[3]?.v,
  }));

  return rows.reduce((result, medal) => {
  let tournament = result.find(
    item => item.tournament === medal.tournament
  );

  if (!tournament) {
    tournament = {
      tournament: medal.tournament,
      medals: {
        Oro: [],
        Argento: [],
        Bronzo: []
      }
    };

    result.push(tournament);
  }

  tournament.medals[medal.type].push({
    speciality: medal.speciality,
    athleteName: medal.athleteName
  });

  return result;
}, []);
}